import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/charts/styles.css';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './app';
import { AuthProvider } from './providers/auth-context';
import { theme } from './theme';

const root = createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <MantineProvider theme={theme}>
            <Notifications position='top-right' />
            <AuthProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </AuthProvider>
        </MantineProvider>
    </React.StrictMode>,
);
